import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Real Estate Agent",
    company: "Coldwell Banker",
    quote: "I used to hand out 100 business cards at open houses. Maybe 2 people would call. Now? Every serious buyer has my contact saved. Game changer.",
    avatar: "SM",
  },
  {
    name: "Marcus Chen",
    role: "Financial Advisor",
    company: "Morgan Stanley",
    quote: "A client told me 'I almost forgot about you, but then I saw your face in my contacts and remembered our conversation.' That's the power of QCard.",
    avatar: "MC",
  },
  {
    name: "Jennifer Brooks",
    role: "Management Consultant",
    company: "Deloitte",
    quote: "No more 'who was that person again?' moments. I'm saved right next to their family and close friends. When they need consulting, they think of me first.",
    avatar: "JB",
  },
];

const industryLogos = [
  "Real Estate",
  "Financial Services",
  "Consulting",
  "Legal",
  "Healthcare",
  "Tech",
];

const TestimonialsSectionV2 = () => {
  return (
    <section className="py-24 bg-slate-950">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/20 text-primary text-sm font-semibold mb-4 border border-primary/30">
            Success Stories
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
            Professionals Who{" "}
            <span className="text-primary">Refuse to Be Forgotten</span>
          </h2>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="relative bg-white/5 backdrop-blur-sm rounded-3xl border border-white/10 p-8 hover:border-primary/30 transition-all duration-300 group"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-primary/10" />
              
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-primary text-primary" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-white/80 mb-8 leading-relaxed text-lg">
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-qcard-coral flex items-center justify-center text-white font-bold text-lg">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-semibold text-white">{testimonial.name}</p>
                  <p className="text-sm text-white/50">{testimonial.role}</p>
                  <p className="text-xs text-primary">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Industry Logos */}
        <div className="text-center">
          <p className="text-white/40 text-sm mb-6">Trusted by professionals in</p>
          <div className="flex flex-wrap justify-center gap-4">
            {industryLogos.map((industry, index) => (
              <span
                key={index}
                className="px-6 py-3 rounded-full bg-white/5 border border-white/10 text-white/60 text-sm font-medium"
              >
                {industry}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSectionV2;
